<template>
  <section class="notifications navbar-notifications">
    <header class="cardHeader card-header">
      <!-- <div class="text-center mb-sm">
        <strong>شما <span class="text-danger" >25</span> پیام دیده نشده دارید</strong>
      </div> -->
      <b-button-group id="notification-b-buttons" class="w-100">
        <b-button variant="default" @click="changeNotificationsTab(1)">
          <b-badge variant="warning " class="animate__animated animate__bounceIn text-dark" style="padding: 6px 9px">{{ $store.state.TaskCount }}</b-badge>
          کـارهـا فعال
        </b-button>
        <b-button variant="default" @click="changeNotificationsTab(2)">
          <b-badge variant="dark" class="animate__animated animate__bounceIn text-warning" style="padding: 6px 9px">{{ CountTicket }}</b-badge>
          تیکت فعال
        </b-button>
      </b-button-group>
    </header>
    <ul v-if="notificationsTabSelected === 1" class="list-group listGroup thin-scroll">
      <li v-for="item in TaskDataProps" :key="item.id" class="list-group-item">
        <span class="notificationIcon d-none d-lg-block thumb-sm">
          <i class="fa fa-bolt fa-lg text-secondary" />
        </span>
        <p class="m-0 overflow-hidden text-right" dir="rtl">
          {{ item.TaskSubject.length > 59 ? item.TaskSubject.slice(0, 60) + '...' : item.TaskSubject }}
          <time class="help-block m-0 text-left">
            <span> {{ item.TaskDate }}</span>
            <small class="float-right ml-2"> {{ item.CustomerName }}</small>
            <span class="float-right"> {{ item.CustomerCode }}</span>
          </time>
        </p>
        <b-button v-if="item.IsView == false" size="xs" variant="danger" @click="OnEditNew(item)" class="m-1">مشاهده</b-button>
        <b-button v-else size="xs" variant="info" @click="OnEditNew(item)" class="m-1">ویرایش</b-button>
        <b-button size="xs" variant="success" @click="DoneTask(item)" class="m-1">انجام شد</b-button>
      </li>
    </ul>
    <!-- <Messages v-else-if="notificationsTabSelected === 2" /> -->

    <b-list-group v-else-if="notificationsTabSelected === 2" class="listGroup thin-scroll">
      <b-list-group-item v-for="item in listTicket" @click="GoToTicket(item)" :key="item.id" class="listGroupItem Pointer">
        <span class="notificationIcon thumb-sm">
          <img class="rounded-circle" :src="item.CustomerLogo" alt="..." />
          <i class="status status-bottom bg-success" />
        </span>
        <small class="text-link help float-right">{{ item.Title.length > 19 ? item.Title.slice(0, 20) + '...' : item.Title }} ({{ item.CustomerCode }})</small>
        <br />
        <p class="text-right m-0">
          {{ item.Description.length > 59 ? item.Description.slice(0, 60) + '...' : item.Description }}
        </p>
        <hr />
        <h6 class="m-0 mb-1">{{ item.DateTimeInsert }}</h6>
      </b-list-group-item>
    </b-list-group>
    <footer class="cardFooter text-sm card-footer">
      <span class="fs-mini">SyncedTask</span>
      <b-button variant="link" @click="SearchTask()">
        <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span>
        <i v-else class="la la-refresh" />
      </b-button>
    </footer>
  </section>
</template>

<script>
import Vue from 'vue'
import Messages from './NotificationsDemo/Messages'
import { createAvatar } from '@dicebear/avatars'
import * as style from '@dicebear/avatars-identicon-sprites'
export default {
  name: 'Notification',
  components: {
    Messages,
  },
  data() {
    return {
      tarixAz: null,
      tarixTa: this.$store.state.JalaliDate,
      notificationsTabSelected: 1,
      newNotifications: null,
      isLoad: false,
      DataAxios_GetdatRiz: { ArryfildValue: {} },
      TaskCount: 0,
      CountTicket: 0,
      CustomerLogo: null,
      listTask: [],
      listTicket: [],
      userId: this.$session.get('UserInfo').tblUserId,
      value: [1791, 1793, 1794, 1795, 1797, 1798],
      value2: [],
      value3: [],
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      TaskDataProps: [],
      TicketDataProps: [],
      infoTaskStatus: {},
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_comboDepUser: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_Users: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
    }
  },
  methods: {
    changeNotificationsTab(tab) {
      Vue.set(this, 'notificationsTabSelected', tab)
      Vue.set(this, 'newNotifications', null)
      this.SearchTask()
      this.SearchTicket()
    },
    DoneTask(row) {
      if (row.IsReply) {
        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success mx-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
        swalWithBootstrapButtons
          .fire({
            title: 'این کـار نیاز به پاسخ دارد ',
            text: '',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'پاسخ',
            cancelButtonText: 'انصراف',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$store.state.OldDataForLog = JSON.stringify(row)
              row.Done = true
              row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
              row.IsView = true
              this.DataAxiosUpdate.Action = 'Task'
              this.DataAxiosUpdate.ArryfildValue = row
              this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                  if (data.status == 'Ok') {
                    this.$SetLog(row, 0, 1)
                    this.infoTaskStatus = data.taskStatus
                  } else {
                    this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                      action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        },
                      },
                    })
                  }
                })
                .finally(() => {
                  this.$router.push({ name: 'ReplyTask', params: { Status: 'Add', TaskStatus: this.infoTaskStatus } })
                })
            }
          })
      } else {
        this.$store.state.OldDataForLog = JSON.stringify(row)

        row.Done = true
        row.IsView = true
        row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        this.DataAxiosUpdate.Action = 'Task'
        this.DataAxiosUpdate.ArryfildValue = row
        this.$PutData_Body(this.DataAxiosUpdate)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$SetLog(row, 0, 1)
              this.$toasted.success('فعالیت با موفقیت انجام شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
            } else {
              this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(10000)
                  },
                },
              })
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$store.state.renderComponent = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
              this.$store.state.renderComponent = true
            })
          })
      }
    },
    OnEditNew(row) {
      if (this.$route.name != 'DetailTask') {
        if (row.IsView == true) {
          this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
        } else {
          this.$store.state.OldDataForLog = JSON.stringify(row)
          row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
          row.IsView = true
          this.DataAxiosUpdate.Action = 'Task'
          this.DataAxiosUpdate.ArryfildValue = row
          this.$PutData_Body(this.DataAxiosUpdate)
            .then((data) => {
              if (data.status == 'Ok') {
                row.DateView = data.taskStatus.dateView
                this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
              } else {
                this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                  action: {
                    text: 'بستن',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(10000)
                    },
                  },
                })
              }
            })
            .finally(() => {})
        }
      }
    },
    SearchTask() {
      this.$store.state.TaskRows = []
      this.listTask = []
      this.DataAxios_GetdatRiz.Action = 'Task/Index'
      this.DataAxios_GetdatRiz.ArryfildValue.tblUserId = this.$session.get('UserInfo').tblUserId
      this.DataAxios_GetdatRiz.ArryfildValue.Done = 'NoDone'
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateAz = this.tarixAz
      this.DataAxios_GetdatRiz.ArryfildValue.TaskDateTa = this.tarixTa
      this.DataAxios_GetdatRiz.Method = 'Post'
      ;(this.DataAxios_GetdatRiz.Token = this.$session.get('Token')),
        this.$PostData(this.DataAxios_GetdatRiz)
          .then((data) => {
            this.list = data
            let filter = data.filter((x) => x.Done == false)
            this.TaskCount = filter.length
            this.$store.state.TaskCount = this.TaskCount
          })
          .finally(() => {
            for (let index = 0; index < this.list.length; index++) {
              if (this.list[index].Done == false) {
                this.listTask.push(this.list[index])
              }
            }
            this.TaskDataProps = this.listTask
          })
    },
    GoToTicket(ticket) {
      this.$router.push({
        name: 'ChatRoom',
        params: {
          chatRoomId: ticket.TblChatRoomId,
          ticketManagerTblUserId: ticket.TblUserId,
          ticketId: ticket.Id,
          tblComboIdTicketStatus: ticket.TblComboGrpId41,
          departmentId: ticket.TblDepartmentId,
          customerName: ticket.CustomerName,
          customerCode: ticket.CustomerCode,
          tblCustomerId: ticket.TblCustomerId,
          tblComboGrpId42: ticket.TblComboGrpId42,
          tblComboGrpId45: ticket.TblComboGrpId45,
        },
      })
    },
    async SearchTicket() {
      var DataaxiosDepUser = {
        Action: 'Ticket',
        Method: 'Post',

        ArryfildValue: {
          ListDepId: this.value2,
          ListGrp41: this.value,
          tblCustomerId: 0,
          ListUsers: this.value3,
        },
      }
      this.$PostData(DataaxiosDepUser)
        .then((response) => {
          this.CountTicket = response.length
          for (let index = 0; index < response.length; index++) {
            let svgCustomer = createAvatar(style, {
              seed: response[index].TblCustomerId + '',
            })
            var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)))
            this.CustomerLogo = 'data:image/svg+xml;base64,' + svg64Customer
            response[index].CustomerLogo = this.CustomerLogo
          }
          this.listTicket = response
        })
        .catch((error) => {
          console.error('CATCH', error)
        })
    },
  },
  created() {
    this.TaskDataProps = this.TaskData
  },
  mounted() {
    if (this.$session.has('CustomerInfo')) {
    } else {
      this.DataAxios_GetData.Action = 'TblCrmCombo/GetComboById'
      this.DataAxios_GetData.Method = 'POST'
      this.DataAxios_GetData.ArryfildValue = { Id: 41 }
      this.$PostData(this.DataAxios_GetData)
        .then((data) => {
          // if (data.status != 'Not Ok') {
          //     this.options = data;
          // }
        })
        .finally(() => {
          this.DataAxios_GetData_comboDepUser.Action = 'TblCrmCombo/GetDepartemanUser/' + this.userId
          this.DataAxios_GetData_comboDepUser.Method = 'POST'
          this.$PostData(this.DataAxios_GetData_comboDepUser)
            .then((data) => {
              if (data.status != 'Not Ok') {
                // this.options2 = data;
                for (let index = 0; index < data.length; index++) {
                  this.value2.push(data[index].id)
                }
              }
            })
            .finally(() => {
              this.DataAxios_GetData_Users.Action = 'TblCrmCombo/GetUserDatails'
              this.DataAxios_GetData_Users.Method = 'POST'
              this.$PostData(this.DataAxios_GetData_Users)
                .then((data) => {
                  if (data.status != 'Not Ok') {
                    // this.options3 = data;
                    for (let index = 0; index < data.length; index++) {
                      if (data[index].id == this.userId) {
                        this.value3.push(data[index].id)
                      }
                    }
                  }
                })
                .finally(() => {
                  this.SearchTicket()
                })
            })
        })
    }
  },
  props: ['TaskData'],
}
</script>

<style src="./Notifications.scss" lang="scss" />
<style src="./ListGroup.scss" lang="scss" />
